// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","729":"goodsList"}[chunkId] + "." + {"443":"fad30c10","729":"e560b477"}[chunkId] + ".js";
};